import React, { useState, useEffect } from 'react';
import { getDocuments } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { FiFileText, FiDownload } from 'react-icons/fi';

const MesDocuments = () => {
  const { user } = useAuth();
  const [documents, setDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    getDocuments({ user_id: user.id }).then(r => {
      const docs = r.data.data || r.data || [];
      setDocuments(Array.isArray(docs) ? docs : []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [user]);

  if (loading) return <div>Chargement...</div>;

  return (
    <div>
      <h1 className="page-title">Mes documents</h1>

      <div className="card">
        <div className="card-header">
          <span><FiFileText /> Documents ({documents.length})</span>
        </div>
        <div className="card-body">
          {documents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
              <FiFileText style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem' }} />
              <p style={{ color: '#888', fontSize: '1.1rem' }}>Aucun document disponible.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="data-table">
                <thead>
                  <tr><th>Date</th><th>Libellé</th><th>Type</th><th>Étape</th><th>Action</th></tr>
                </thead>
                <tbody>
                  {documents.map((d: any) => (
                    <tr key={d.id}>
                      <td>{d.date ? new Date(d.date).toLocaleDateString('fr-FR') : (d.created_at ? new Date(d.created_at).toLocaleDateString('fr-FR') : '-')}</td>
                      <td>{d.libelle || d.nom || '-'}</td>
                      <td><span className="badge badge-blue">{d.type || '-'}</span></td>
                      <td>{d.etape || '-'}</td>
                      <td>
                        {d.url ? (
                          <a href={d.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                            <FiDownload /> Télécharger
                          </a>
                        ) : (
                          <span style={{ color: '#999' }}>-</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MesDocuments;
